export default __webpack_public_path__ + "static/media/EN_05.6889175c.svg";